import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import StudentDashboard from './pages/StudentDashboard';
import AdminDashboard from './pages/AdminDashboard';
import EmployeeDashboard from './pages/EmployeeDashboard';
import ProtectedRoute from './ProtectedRoute';
import BackButtonModal from './BackButtonModal';

function BackButtonHandler() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showBackModal, setShowBackModal] = useState(false);

  useEffect(() => {
    const isAuthenticated = sessionStorage.getItem('authenticated');
    if (!isAuthenticated) return;

    window.history.pushState(null, '', window.location.href);

    const handlePopState = () => {
      window.history.pushState(null, '', window.location.href);
      setShowBackModal(true);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [location]);

  const handleConfirm = () => {
    setShowBackModal(false);
    sessionStorage.clear();
    navigate('/', { replace: true });
  };

  const handleCancel = () => {
    setShowBackModal(false);
  };

  return (
    <>
      {showBackModal && (
        <BackButtonModal
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}
    </>
  );
}

function App() {
  return (
    <Router>
      <BackButtonHandler />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/student" element={
          <ProtectedRoute allowedRole="student">
            <StudentDashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin" element={
          <ProtectedRoute allowedRole="admin">
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/employee" element={
          <ProtectedRoute allowedRole="employee">
            <EmployeeDashboard />
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;